import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Cooperative} from "../../../../../shared/model/cooperative";
import {HttpCustomService} from "../../../../../service/http-custom.service";
import {checkUniqueCooperativeCode} from "../../../../../shared/validator/cooperative-validator";
import {checkUniqueUserName} from "../../../../../shared/validator/user-validator";
import * as _ from "lodash";
import * as moment from 'moment';
import {checkDatePeriod} from "../../../../../shared/validator/date-validator";

@Component({
  selector: 'omni-cooperative-info',
  templateUrl: './cooperative-info.component.html',
  styleUrls: ['./cooperative-info.component.scss']
})
export class CooperativeInfoComponent implements OnInit, OnChanges {
  formGroup: FormGroup;
  @Input() cooperative: Cooperative;
  @Input() isEdit = false;
  defaultValue: Cooperative;
  minDate = new Date();

  constructor(
    private fb: FormBuilder,
    private http: HttpCustomService
  ) { }

  ngOnInit(): void {
    if (!this.isEdit) {
      this.buildForm();
    }
  }

  private buildForm() {
    this.formGroup = this.fb.group({
      cooperativeNo: [null],
      cooperativeCode: [null, Validators.required],
      cooperativeName: [null],
      effectiveStartDate: [new Date()],
      effectiveEndDate: [null, checkDatePeriod()],
      closingDate: [null, [Validators.required, Validators.min(1), Validators.max(28)]],
      userNo: [null],
      userName: [null, Validators.required],
      password: [null, Validators.required]
    });
    this.formGroup.get('cooperativeCode').setAsyncValidators(checkUniqueCooperativeCode(this.http));
    this.formGroup.get('userName').setAsyncValidators(checkUniqueUserName(this.http));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cooperative && !_.isEqual(changes.cooperative.previousValue, changes.cooperative.currentValue) && !_.isEmpty(this.cooperative)) {
      if (_.isNil(this.formGroup)) {
        this.buildForm();
      }
      this.formGroup.patchValue({
        cooperativeNo: this.cooperative.cooperativeNo,
        cooperativeCode: this.cooperative.cooperativeCode,
        cooperativeName: this.cooperative.cooperativeName,
        effectiveStartDate: moment(this.cooperative.effectiveStartDate, 'DD/MM/YYYY'),
        effectiveEndDate: this.cooperative.effectiveEndDate ? moment(this.cooperative.effectiveEndDate, 'DD/MM/YYYY') : null,
        closingDate: this.cooperative.closingDate,
        userNo: this.cooperative.userNo,
        userName: this.cooperative.userName,
        password: this.cooperative.rawPassword
      });
    }
  }

  ngAfterViewInit() {
    _.assign(this.defaultValue, this.formGroup.getRawValue());
  }
}
